// extracted by mini-css-extract-plugin
module.exports = {"mypage_subsc_payment":"method_mypage_subsc_payment__T6zbD"};